import React from 'react';

import SuccessfulMonitor from 'shared/ui/icons/SuccessfulMonitor';
import ProblemMonitor from 'shared/ui/icons/ProblemMonitor';
import PauseMonitor from 'shared/ui/icons/PauseMonitor';
import UnknownMonitor from 'shared/ui/icons/UnknownMonitor';
import {PALETTE} from 'shared/config/model/palette';

interface IMonitorIconStatusProps {
    isPaused?: boolean;
    incompleteResult?: boolean;
    ok?: boolean | null;
}

const MonitorIconStatus: React.FC<IMonitorIconStatusProps> = ({
    isPaused = false,
    incompleteResult,
    ok,
}) => {
    return (
        <div>
            {isPaused && <PauseMonitor />}

            {ok === null && !isPaused && <UnknownMonitor />}

            {ok === false && !incompleteResult && !isPaused && <ProblemMonitor />}

            {ok === true && !incompleteResult && !isPaused && (
                <SuccessfulMonitor />
            )}

            {ok === false && incompleteResult && !isPaused && (
                <UnknownMonitor color={PALETTE.error} />
            )}

            {ok === true && incompleteResult && !isPaused && (
                <UnknownMonitor color={PALETTE.success} />
            )}
        </div>
    );
};

export default MonitorIconStatus;